// @flow
import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import Input from '../../../../../components/Input';
import TextareaInput from '../../../../../components/TextareaInput';
import {
  WizardForm,
  FormTitleH5
} from '../../../../../components/WizardFormStyles';
import { DefaultIcon } from '../../../../../components/Icon';
import DropdownInput from '../../../../../components/DropdownInput';
import CheckboxInput from '../../../../../components/CheckboxInput';
import SubmitButton from '../../../../../components/SubmitButton';
import RadioInput from '../../../../../components/RadioInput';
import { handleNext } from '../handleSubmit';
import { type ProcessingVolumes } from '..';
import { arrayToOptions } from '../../../../../utilities/misc';
import {
  maxLength255,
  requiredBooleanField,
  requiredField
} from '../../../../../utilities/validations';

type Props = {
  error: string,
  handleSubmit: Function,
  no_website: boolean,
  submitting: boolean,
  processingVolumes: ProcessingVolumes,
  website: ?string
};
class AboutTheCompany extends Component<Props> {
  static acceptedFileTypes = '.pdf, .jpg, .jpeg, .png';

  processingVolumeOptions = () =>
    arrayToOptions(this.props.processingVolumes, 'range', 'id');

  render() {
    return (
      <WizardForm onSubmit={this.props.handleSubmit}>
        <FormTitleH5 hideOnMobile>
          <DefaultIcon name="certificate" />
          <span>About the Company</span>
        </FormTitleH5>
        <Field
          name="company_detail_attributes.description"
          label="Please describe what your company does (max. 255 characters)"
          component={TextareaInput}
          validate={[requiredField, maxLength255]}
        />
        <Field
          name="company_detail_attributes.processing_volume"
          label="Anticipated monthly processing volume (optional)"
          component={DropdownInput}
          options={this.processingVolumeOptions()}
        />
        <Field
          name="company_detail_attributes.type_of_company"
          label="Company type"
          component={DropdownInput}
          options={[
            { text: 'Corporation', value: 'Corporation' },
            { text: 'Partnership', value: 'Partnership' },
            { text: 'Sole Proprietorship', value: 'Personal' }
          ]}
          validate={requiredField}
        />
        <Field
          name="company_detail_attributes.processing_method"
          label="How will you process cryptocurrency payments?"
          component={RadioInput}
          options={[
            {
              text: 'Online',
              value: 'online'
            },
            {
              text: 'In-store',
              value: 'in_store'
            },
            {
              text: 'Both',
              value: 'both'
            }
          ]}
          validate={requiredBooleanField}
        />
        <Field
          name="company_detail_attributes.website"
          label="Website or link to Social Media page"
          component={Input}
          disabled={this.props.no_website}
        />
        <Field
          name="company_detail_attributes.no_website"
          label="I don't have a website or any social media set up yet"
          component={CheckboxInput}
          validate={this.props.website ? null : requiredField}
          validationTextAlign="left"
        />

        <Field
          name="company_detail_attributes.documentation_available"
          label="We will require offical gov't documentation for proof of company and ownership to enable payouts. Do you have any government-issued documents verifying your business? "
          component={RadioInput}
          options={[
            { text: 'Yes', value: 'yes' },
            { text: 'No', value: 'no' },
            {
              text: 'Currently Obtaining',
              value: 'currently_obtaining'
            }
          ]}
          validate={requiredBooleanField}
        />
        <SubmitButton
          error={this.props.error}
          value="Next"
          disabled={this.props.submitting}
        />
      </WizardForm>
    );
  }
}

export default reduxForm({
  form: 'verification',
  forceUnregisterOnUnmount: true,
  destroyOnUnmount: false,
  onSubmit: handleNext

  // $FlowFixMe
})(AboutTheCompany);
